module.exports = __webpack_public_path__ + "static/media/bol-image.41ae0c3a.svg";